import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';
import {CardModule} from './card.module';
import {enableProdMode} from '@angular/core';

enableProdMode();
const platform = platformBrowserDynamic();
platform.bootstrapModule(CardModule);


// WEBPACK FOOTER //
// ./src/app/card/main.ts